// extracted by mini-css-extract-plugin
module.exports = {"module":"statuses_module__2bdhn","item":"statuses_item__LLR6L"};